<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <b-field v-if="products">
          <b-input v-model="searchName" placeholder="Search products in this city"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <a class="button full-width-button is-outlined is-primary" @click="openModal">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span>Add</span>
          </a>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-3" v-for="product in filterBy(products, searchName)" :key="product.docId">
        <div class="card">
          <div class="has-text-centered">
            <img class="product-image" :src="product.product.imageUrl || '/static/placeholder_image.png'" alt="Placeholder image">            
          </div>
          <div class="card-content">
            <strong class="subtitle" :title="product.product.name">{{product.product.name | truncate(10)}}</strong>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item" @click="deleteProduct(product)">Delete</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddProduct from "./AddProduct";
import ProductsService from "./service";

export default {
  name: "products",

  props: ["city"],

  created() {
    this.fetchProducts();
  },

  data() {
    return {
      isLoading: true,
      products: null,
      searchName: null
    };
  },

  methods: {
    fetchProducts() {
      ProductsService.all(this.city).then(data => {
        this.products = data;
        this.isLoading = false;
      });
    },

    deleteProduct(productToBeDeleted) {
      this.$dialog.confirm({
        message: "Sure to delete product?",
        onConfirm: () => {
          this.isLoading = true;

          ProductsService.deleteProduct(this.city, productToBeDeleted).then(
            () => {
              this.products = this.products.filter(
                product => product.docId !== productToBeDeleted.docId
              );
              this.isLoading = false;
              this.$toast.open("Product deleted successfully");
            }
          );
        }
      });
    },

    openModal() {
      this.$modal.open({
        parent: this,
        props: {
          city: this.city,
          products: this.products
        },
        component: AddProduct,
        hasModalCard: true
      });
    }
  }
};
</script>

<style scoped>
.product-image {
  height: 100px;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/cities/Products/Products.vue